import { render, staticRenderFns } from "./TemplateCategoryItem.vue?vue&type=template&id=523faaf8&scoped=true"
import script from "./TemplateCategoryItem.vue?vue&type=script&lang=ts"
export * from "./TemplateCategoryItem.vue?vue&type=script&lang=ts"
import style0 from "./TemplateCategoryItem.vue?vue&type=style&index=0&id=523faaf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523faaf8",
  null
  
)

export default component.exports